/* eslint-disable */
import { mapGetters } from "vuex"
import { ResourceCacheMixin } from "./ResourceCacheMixin"

export const SiteBookingResourceOrderSettingMixin = {
    mixins: [ResourceCacheMixin],
    data() {
        return {
            resourcesForNewClients: [],
            resourcesForRegisteredClients: []
        }
    },
    computed: {
        ...mapGetters('AppSettings', [
            'findAppSetting'
        ]),
        resoureceOrderSettingCache() {
            return this.findAppSetting('BookingResourceOrder');
        },
        resourceOrderSetting() {
            return !!this.resoureceOrderSettingCache ? this.resoureceOrderSettingCache.value : null;
        },
        resourceOrderSettingString() {
            return !!this.resourceOrderSetting ? this.resourceOrderSetting.value : '';
        },
        resourceOrderSettingObject() {
            return !!this.resourceOrderSettingString ? JSON.parse(this.resourceOrderSettingString) : null;
        },
        forNewClients() {
            return !!this.resourceOrderSettingObject ? this.resourceOrderSettingObject.forNewClients : [];
        },
        forRegisteredClients() {
            return !!this.resourceOrderSettingObject ? this.resourceOrderSettingObject.forRegisteredClients : [];
        }
    },
    watch: {
        resources() {
            this.refreshSettingData();
        },
        settingObject() {
            this.refreshSettingData();
        }
    },
    methods: {
        refreshSettingData(){
            const resourceIds = this.bookableResources.map(r => r.id);
            this.resourcesForNewClients = [
                ...new Set([
                    ...this.forNewClients,
                    ...resourceIds
                ])
            ].filter(id => resourceIds.includes(id));
            this.resourcesForRegisteredClients = [
                ...new Set([
                    ...this.forRegisteredClients,
                    ...resourceIds
                ])
            ].filter(id => resourceIds.includes(id));
        }
    },
    created() {
        this.refreshSettingData();
    }
}
